module.exports = __webpack_public_path__ + "img/me2.1367363f.jpg";